import {Component} from '@angular/core';
import {CrPolicyProduct} from './cr-policy-product';
import {ControlContainer, NgForm} from '@angular/forms';
import {PolicyContractVersionService} from '../../../../../bonding_shared/services';
import {GlobalConditionsOfInsurance} from '../../../../../bonding_shared/model/dictionary-ids';

@Component({
  selector: 'top-up-product',
  templateUrl: './top-up-product.component.pug',
  viewProviders: [{provide: ControlContainer, useExisting: NgForm}],
})
export class TopUpProductComponent extends CrPolicyProduct {
  constructor(policyContractVersionService: PolicyContractVersionService) {
    super(policyContractVersionService);
  }

  readonly GlobalConditionsOfInsurance = GlobalConditionsOfInsurance;
}
